import { PhaseBase } from "@design-system";
import { PHASE_FRAGMENT } from "../../graphql/fragment/phase-fragment";

export const addPhaseToCache = (cache: any, phase: PhaseBase, matterId: number): void => {
  const newPhaseRef = cache.writeFragment({
    data: phase,
    fragment: PHASE_FRAGMENT,
    fragmentName: "PhaseParts",
  });
  cache.modify({
    id: `Matter:${matterId}`,
    fields: {
      phases(existingPhaseRefs = [], { readField }: any) {
        if (existingPhaseRefs.some((ref: any) => readField("id", ref) === phase?.id)) {
          return existingPhaseRefs;
        }
        return [...existingPhaseRefs, newPhaseRef];
      },
    },
  });
};
